interface Props {
  name: string;
}
const SampleCropDisplay = ({
  name
}: Props) => {
  return <div className="bg-neutral-300 h-full w-full flex items-center justify-center overflow-hidden rounded-full" data-sentry-component="SampleCropDisplay" data-sentry-source-file="SampleCropDisplay.tsx">
      <span>{name}</span>
    </div>;
};
export default SampleCropDisplay;